import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { handleHttp, formfileHandle } from "@/utils/utils";
import uploadfile from '@/components/mapv2/uploadfile';
import fontStyle from '@/components/mapv2/fontstyle';
import sliderInput from '@/components/mapv2/sliderinput';
import { mapMutations } from 'vuex';
let _ = require('lodash');
export default {
  props: {
    styleIndex: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: []
    },
    name: {
      type: String,
      default: ''
    },
    showTab: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '按钮'
    }
  },
  components: {
    fontStyle,
    uploadfile,
    sliderInput
  },
  data() {
    return {
      fontname: 'btnfont',
      switchtab2: '0',
      style: {},
      btnstyle: [],
      once: false,
      defaultfont: {},
      width: 220,
      height: 40,
      margin: 5,
      imgList: [],
      key1: 0,
      bgfield: {
        fieldType: {
          type: 'img'
        },
        verify: {
          limitCount: 0,
          limitHeight: 0,
          limitSize: 0,
          limitType: '',
          limitWidth: 0,
          maxValue: {
            errMsg: '上传个数最大限制',
            range: 1
          },
          minValue: {
            errMsg: '上传个数最小限制',
            range: ''
          }
        }
      },
      borderRadius: 5,
      backgroundColor: ''
    };
  },
  watch: {
    value: {
      handler(val) {
        this.switchtab2 = '0';
        this.btnstyle = [];
        this.btnstyle = [...this.value];
        this.defaultHandle(0);
        this.setStyleItem();
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.value.length > 0) {
        this.switchtab2 = '0';
        this.btnstyle = [];
        this.btnstyle = [...this.value];
        this.defaultHandle(0);
        this.setStyleItem();
      } else {
        this.updateChange();
      }
    });
  },
  methods: {
    ...mapMutations(['SET_MAPSTYLEITEM']),
    defaultHandle(index) {
      this.key1++;
      this.style = {
        ...this.btnstyle[Number(index)]
      };
      this.imgList = JSON.parse(JSON.stringify(this.style.imgList));
      this.defaultfont = Object.assign({}, this.style);
      this.width = parseInt(this.style.width);
      this.height = parseInt(this.style.height);
      this.margin = parseInt(this.style.margin);
      this.backgroundColor = this.style.backgroundColor ? this.style.backgroundColor : 'rgba(255, 255, 255, 0)';
    },
    handleClick(val) {
      this.once = true;
      this.defaultHandle(val.index);
    },
    fontChange(val) {
      Object.keys(val[this.fontname]).forEach(key => {
        this.style[key] = val[this.fontname][key];
      });
      this.updateChange();
    },
    inputChange(val, type) {
      let value = `${val}px`;
      // if (type === 'margin') value = `${val}px`
      if (type === 'height') this.style.lineHeight = value;
      this.style[type] = value;
      this.updateChange();
    },
    fileListHandle(val) {
      this.style.imgList = val.length > 0 ? formfileHandle(val, 'imagebox', this.$route.query.uid) : [];
      this.imgList = _.cloneDeep(this.style.imgList);
      this.updateChange();
    },
    updateChange() {
      if (!this.once && this.value.length === 0) {
        if (!this.style.imgList) this.style.imgList = [];
        this.btnstyle[0] = {
          ...this.style
        };
        if (this.styleIndex === 0 && this.showTab) this.btnstyle[1] = {
          ...this.style
        };
      } else {
        let index = Number(this.switchtab2);
        this.btnstyle[index] = {
          ...this.style
        };
      }
      this.setStyleItem();
    },
    setStyleItem() {
      let obj = {};
      obj[this.name] = this.btnstyle;
      this.SET_MAPSTYLEITEM(obj);
    },
    colorHandle(val, type) {
      this.style[type] = val;
      this.updateChange();
    },
    /**
     * 打开素材库
     * @date 2025-06-18
     */
    openSourceMaterial(type) {
      let obj = {
        type: type,
        pic: this.imgList,
        typebtnIndex: this.switchtab2
      };
      this.$emit('openSource', obj);
    },
    changePic(data) {
      console.log(`data`, data);
      if (data.picture_upload.length > 0) {
        this.imgList = _.cloneDeep(data.picture_upload);
        this.style.imgList = this.imgList;
      }
    }
  }
};